module.exports = __webpack_public_path__ + "static/media/19a.f6d18007.jpg";